"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonNavigationDropdownItem = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const BronsonNavigationDropdownItem = (props) => {
    return (React.createElement("li", { className: 'c-page-head-nav__dropdown-list-item c-site-nav-dropdown__item' },
        React.createElement(react_router_dom_1.Link, { id: props.routeId || '', to: props.route.path, className: 'c-page-head-nav__dropdown-list-link c-site-nav-dropdown__link', onClick: props.onCloseMenu }, props.route.label)));
};
exports.BronsonNavigationDropdownItem = BronsonNavigationDropdownItem;
